import { deepmerge } from '@mui/utils'
import base from './base'
import colors from './colors'

const scopeOptions = deepmerge(base, { palette: colors })

export default scopeOptions
